import { api } from '../api'
import { StudioCampaignPages, StudioCampaign } from 'models/StudioCampaign'

const campaignsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCampaign: builder.query<StudioCampaign, string>({
      query: (campaignId: string) => `/studio-campaigns/${campaignId}?published=1`,
    }),
    getPages: builder.query<StudioCampaignPages, string>({
      query: (campaignId: string) => `/studio-campaigns/${campaignId}/pages?published=1`,
    }),
  }),
})

export const {
  useGetCampaignQuery,
  useGetPagesQuery,
  endpoints: { getCampaign, getPages },
} = campaignsApi

export default campaignsApi
